import React from 'react';

import ViewOrderPage from '@/features/orders/pages/view-order.page';

const ViewOrderRoute = () => {
  return <ViewOrderPage />;
};

export default ViewOrderRoute;
